import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import styles from "./styles.module.scss";
import { toast, Toaster, ToastBar } from "react-hot-toast";
import useCommonStore from "../../stores/common";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import CloseIconWhite from "../../assets/svg/icons/common/CloseIconWhite";
import ChevronLeft24 from "../../assets/svg/icons/common/ChevronLeft24";

const ListDetailsSubLayout = ({
  listComponent: ListComponent,
  detailsComponent: DetailsComponent,
  mobileHeaderActions = null,
}) => {
  const showDetails = useCommonStore((state) => state.showDetails);
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const toggleShowDetails = useCommonStore((state) => state.toggleShowDetails);
  const setExpandDetails = useCommonStore((state) => state.setExpandDetails);
  const isMobile = useMediaQuery(1200);

  useEffect(() => {
    if (isMobile) {
      setExpandDetails(true);
    }
  }, [isMobile, setExpandDetails]);

  const handleCloseMobileDetails = () => {
    toggleShowDetails();
  };

  return (
    <>
      <div className={styles.container}>
        {(isMobile ? !showDetails : !expandDetails) && (
          <div className={styles.listSection}>
            <ListComponent />
          </div>
        )}
        <div
          className={`${styles.detailsSection} ${showDetails ? styles.show : ""} ${expandDetails ? styles.expanded : ""}`}
        >
          <div className={styles.mobile_details_header}>
            <button
              className={styles.mobile_details_close_button}
              onClick={handleCloseMobileDetails}
            >
              <ChevronLeft24 />
            </button>
            {mobileHeaderActions && (
              <div className={styles.mobile_header_actions}>
                {mobileHeaderActions}
              </div>
            )}
          </div>
          {showDetails && <DetailsComponent />}
        </div>

        <Toaster
          position="top-right"
          containerStyle={{}}
          toastOptions={{
            style: {
              borderRadius: "8px",
              background: "rgba(40, 39, 45, 0.85)",
              color: "#fff",
              padding: "16px 24px",
            },
            duration: 5000,
          }}
        >
          {(t) => (
            <ToastBar toast={t}>
              {({ icon, message }) => (
                <>
                  {icon}
                  {message}
                  {t.type !== "loading" && (
                    <button
                      className={styles.toast_dismissal_button}
                      onClick={() => toast.dismiss(t.id)}
                    >
                      <CloseIconWhite />
                    </button>
                  )}
                </>
              )}
            </ToastBar>
          )}
        </Toaster>
      </div>
    </>
  );
};

export default withRouter(ListDetailsSubLayout);
